 <template>
    <div class="custom-modal full-mobile vue-modal disable-click-outside review-modal" ref="modal" :class="{'align-start': !formSent}"
         tabindex="0" @keyup.esc="closeModal" @click.self="closeModal">
        <div class="custom-modal-content" :class="{'w-800': !formSent}">
            <div class="custom-modal-close"  @click="closeModal">
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.41503 1.14024C2.01528 0.759169 1.37464 0.76683 0.984114 1.15735C0.59359 1.54788 0.60107 2.17338 1.00082 2.55446L5.54386 6.88523L1.00082 11.216C0.60107 11.5971 0.59359 12.2226 0.984114 12.6131C1.37464 13.0036 2.01528 13.0113 2.41503 12.6302L6.99273 8.2664L11.4194 12.4862C11.8191 12.8673 12.4598 12.8596 12.8503 12.4691C13.2408 12.0786 13.2333 11.4531 12.8336 11.072L8.4416 6.88523L12.8336 2.69846C13.2333 2.31739 13.2408 1.69189 12.8503 1.30136C12.4598 0.910839 11.8191 0.903177 11.4194 1.28425L6.99273 5.50405L2.41503 1.14024Z" fill="#252525"/>
                </svg>
            </div>
            <div v-if="formSent" class="review-success">
                <div class="text-center review-success-image">
                    <IconReviewSuccess/>
                </div>
                <h2 class="review-success-title">Дякуємо за ваш відгук!</h2>
                <p class="text-center review-success-text">Він буде опублікований після перевірки.</p>
                <p class="text-center review-success-text">
                    <span v-if="isEdit">Зміни будуть опубліковані після перевірки.</span>
                    <br v-if="isEdit">
                    Модерація займає 1-3 робочих дні.
                </p>
            </div>
            <form :action="postUrl" class="review-content" @submit.prevent="submit" v-else method="post">
                <h2 class="review-title">{{ isEdit ? 'Відредагувати' : 'Залишити' }} відгук </h2>
                <div class="review-subtitle">Відгук про турнікет <span class="highlight">"{{ name }}"</span></div>
                <div v-if="userInfo.activity && !isEdit">
                    <div>Ваш рід діяльності: <strong>{{ userInfo.activity }}</strong></div>
                </div>
                <div v-else-if="!isEdit" class="review-group">
                    <Dropdown name="Ваш рід діяльності*" :options="positionOptions" :filterselected="formData.position" :is-single-choice="true"
                              @setSelection="changePosition" />
                    <FormErrors v-if="formErrors.position" :errors="formErrors.position"/>
                    <FormInput v-if="showCustomPosition" v-model="formData.customPosition" placeholder="Рід діяльності*" isRequired="true"/>
                    <FormErrors v-if="formErrors.customPosition" :errors="formErrors.customPosition"/>
                </div>
                <div class="review-group">
                    <div class="review-area-wrapper" :class="{focus: commentInFocus, error: formErrors.comment}">
                        <textarea name="comment" id="comment" cols="30" rows="6"
                                  v-model="formData.comment" required placeholder="Ваш відгук*"
                                  class="review-area" @focus="commentInFocus = true" @blur="commentInFocus = false"></textarea>
                        <div v-if="commentInFocus" class="review-area-counter text-second">{{ formData.comment.length }} / 1500</div>
                    </div>
                    <FormErrors v-if="formErrors.comment" :errors="formErrors.comment"/>
                </div>
                <div class="review-group">
                    <div class="review-area-wrapper" :class="{focus: conclusionInFocus, error: formErrors.conclusion}">
                        <textarea name="conclusion" id="conclusion" cols="30" rows="3"
                                  v-model="formData.conclusion" required placeholder="Основний висновок*"
                                  class="review-area" @focus="conclusionInFocus = true" @blur="conclusionInFocus = false"></textarea>
                        <div v-if="conclusionInFocus" class="review-area-counter text-second">{{ formData.conclusion.length }} / 250</div>
                    </div>
                    <FormErrors v-if="formErrors.conclusion" :errors="formErrors.conclusion"/>
                </div>
                <div class="review-group" v-if="!isEdit">
                    <textarea name="video" id="video" cols="30" rows="1" v-model="formData.video_url"
                              placeholder="Посилання на відео" class="review-area simple" :class="{error: formErrors.video_url}"></textarea>
                    <FormErrors v-if="formErrors.video_url" :errors="formErrors.video_url"/>
                </div>
                <vue-dropzone v-if="!isEdit" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :include-styling="false" :useCustomSlot=true
                              @vdropzone-file-added="onSuccessUpload" @vdropzone-sending="sendingEvent"
                              @vdropzone-success="onSuccessUploadToServer" @vdropzone-removed-file="onRemoveFile"
                              @vdropzone-mounted="onDropZoneMounted" @vdropzone-error="onErrorSending">
                    <div class="upload-section disable-click-outside">
                        <icon-upload-file class="upload-section-icon"/>
                        <p class="upload-section-title">
                            <span class="mobile-hidden">Перенесіть сюди файли, або</span>
                            <span class="upload-section-btn">Завантажте
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.79037 11.3333V5.56034L5.9487 7.402L4.95703 6.37492L8.4987 2.83325L12.0404 6.37492L11.0487 7.402L9.20703 5.56034V11.3333H7.79037ZM4.2487 14.1666C3.85912 14.1666 3.52549 14.0278 3.24782 13.7501C2.97016 13.4724 2.83156 13.139 2.83203 12.7499V10.6249H4.2487V12.7499H12.7487V10.6249H14.1654V12.7499C14.1654 13.1395 14.0265 13.4731 13.7489 13.7508C13.4712 14.0285 13.1378 14.1671 12.7487 14.1666H4.2487Z" fill="#4578EB"/>
                                </svg>
                            </span>
                        </p>
                        <p class="upload-section-text">
                            Фото (jpg, jpeg, png), Документ (pdf)
                        </p>
                    </div>
                </vue-dropzone>
                <FormErrors v-if="formErrors.other" :errors="formErrors.other"/>
                <div v-if="showMaxFileMessage" class="upload-error-max">Ви можете завантажити не більше 5 фото і не більше 2 документів. Якщо необхідно надіслати більше матеріалів по турнікету, просимо додати посилання на ресурс (наприклад, Google Drive) до тексту відгуку.</div>
                <div class="uploaded-images" v-if="isEdit && editedPhotos.length">
                    <div class="upload-preview-wrapper" v-for="(photo, index) in editedPhotos" :key="index">
                        <div class="upload-preview">
                            <img :src="photo.url" :alt="photo.name" class="upload-preview-image">
                        </div>
                    </div>
                </div>
                <div class="uploaded-documents" v-if="isEdit && editedDocs.length">
                    <div class="upload-preview-wrapper document" v-for="(doc, index) in editedDocs" :key="index">
                        <div class="upload-preview disabled">
                            <div class="upload-preview-document">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.75 12.5C1.75 13.7426 2.75736 14.75 4 14.75H10.2485C10.5513 14.75 10.8438 14.6401 11.0717 14.4407L13.8231 12.0332C14.0944 11.7958 14.25 11.4529 14.25 11.0925V4.5C14.25 3.25736 13.2426 2.25 12 2.25H4C2.75736 2.25 1.75 3.25736 1.75 4.5V12.5Z" stroke="#4578EB" stroke-width="1.5"></path>
                                    <path d="M5.25 7H10.75" stroke="#4578EB" stroke-width="1.5" stroke-linecap="round"></path>
                                    <path d="M5.25 10H8.75" stroke="#4578EB" stroke-width="1.5" stroke-linecap="round"></path>
                                </svg>
                            </div>
                            <div class="upload-preview-name"><span>{{ doc.name }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="form-error" v-if="unknownProblem">Невідома помилка при відправці відгуку</div>
                <div class="review-btn-block">
                    <button type="submit" class="btn btn-full" :disabled="sendReviewIsDisabled">Надіслати</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FormInput from './helpers/FormInput.vue';
import {vueData} from '../turniket';
import FormDropdown from './helpers/FormDropdown.vue';
import IconFeedbackSuccess from './icons/IconFeedbackSuccess.vue';
import FormErrors from './helpers/FormErrors.vue';
import Dropdown from "./Dropdown.vue";
import IconReviewSuccess from "./icons/IconReviewSuccess.vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import IconUploadFile from "./icons/IconUploadFile.vue";
import $ from "jquery";

export default {
    props: [
        'postUrl',
        'csrfToken',
        'user'
    ],
    name: "ReviewForm",
    components: {
        IconUploadFile,
        IconReviewSuccess, Dropdown, FormErrors, IconFeedbackSuccess, FormDropdown, FormInput, vueDropzone: vue2Dropzone
    },
    data() {
        return {
            formSent: false,
            isEdit: vueData.isEdit,
            editedReviewId: vueData.tourniquetReviewEditedId,
            name: vueData.tourniquetReviewName,
            isLoading: false,
            showCustomPosition: false,
            showMaxFileMessage: false,
            commentInFocus: false,
            conclusionInFocus: false,
            formData: {
                turniket_id: vueData.tourniquetReviewId,
                position: '',
                customPosition: '',
                comment: vueData.isEdit ? vueData.tourniquetReviewText : '',
                conclusion: vueData.isEdit ? vueData.tourniquetReviewConclusion : '',
                video_url: '',
                photo: [],
                other: []
            },
            editedPhotos: vueData.tourniquetReviewImages,
            editedDocs: vueData.tourniquetReviewDocs,
            uploadedFiles: [],
            errorUploadFiles: false,
            fileIsUploading: false,
            formErrors: {},
            unknownProblem: false,
            positionOptions: [
                'Волонтер',
                'Бойовий медик',
                'Військовий',
                'Медик',
                'Інструктор з домедичної допомоги',
                'Інше'
            ],
            dropzoneOptions: {
                url: '/upload',
                previewTemplate: this.template(),
                thumbnailWidth: 130,
                thumbnailHeight: 90,
                maxFiles: 7,
                maxFilesize: 5,
                maxThumbnailFilesize: 50,
                acceptedFiles: 'image/*, application/pdf',
            }
        }
    },
    beforeDestroy() {
        document.querySelector('body').classList.remove('modal-open')
    },
    created() {
        this.$nextTick(() => {
            document.querySelector('body').classList.add('modal-open');
            if (this.userInfo.activity) {
                this.formData.position = this.userInfo.activity;
            }
        })
    },
    computed: {
        userInfo() {
            return JSON.parse(this.user)
        },
        photosLength() {
            return this.uploadedFiles.filter(item => item.type === 'photo').length
        },
        documentsLength() {
            return this.uploadedFiles.filter(item => item.type === 'other').length
        },
        sendReviewIsDisabled() {
            return this.errorUploadFiles || this.fileIsUploading;
        }
    },
    methods: {
        onErrorSending(file, message, xhr) {
            this.fileIsUploading = false;
            this.errorUploadFiles = !message.status;
            let errorMessage = message.messages ? message.messages.file[0] : "Неможливо завантажити даний файл";
            if (typeof message === 'string' && message.includes('File is too big')) {
                errorMessage = 'Максимальний розмір файлу має бути не більше 5мБ'
            }
            const ukrMessage = message === 'You can not upload any more files.' ? 'Перевищена максимальна кількість файлів.' : errorMessage;
            try {
                file.previewElement.classList.add('-error');
                file.previewElement.querySelector('[data-dz-errormessage]').innerText = errorMessage || ukrMessage;
            } catch (error) {
                console.log(error);
            } finally {
                file.previewElement.querySelector('[data-dz-errormessage]').innerText = ukrMessage;
            }
        },
        onDropZoneMounted() {
            const imagesBlock = document.createElement("div");
            imagesBlock.classList.add('uploaded-images');
            const documentsBlock = document.createElement("div");
            documentsBlock.classList.add('uploaded-documents');
            document.querySelector('#dropzone').append(imagesBlock);
            document.querySelector('#dropzone').append(documentsBlock);
        },
        onSuccessUploadToServer(file, response) {
            this.fileIsUploading = false;
            this.formData[response.type].push({
                'client_name': response.client_name,
                'storage_name': response.storage_name
            });
            this.uploadedFiles.push({
                name: file.name,
                url: response.temporary_download,
                type: response.type
            });
            file.previewElement.querySelector('[data-view]').setAttribute('href', response.temporary_download);

            if (this.photosLength > 5 || this.documentsLength > 2) {
                this.showMaxFileMessage = true;
                this.$refs.myVueDropzone.removeFile(file);
                this.uploadedFiles = this.uploadedFiles.filter(item => item.name !== file.name);
            }
        },
        sendingEvent (file, xhr, formData) {
            this.fileIsUploading = true;
            formData.append('_token', this.csrfToken);
        },
        onSuccessUpload(file) {
            this.fileIsUploading = false;
            this.showMaxFileMessage = false;
            if (file.type === 'application/pdf') {
                file.previewElement.classList.add('document');
                file.previewElement.querySelector('.upload-preview-document').classList.remove('hidden');
                file.previewElement.querySelector('.upload-preview-name').classList.remove('hidden');
                file.previewElement.querySelector('img').remove();
                document.querySelector('#dropzone').querySelector('.uploaded-documents').append(file.previewElement);
            } else {
                document.querySelector('#dropzone').querySelector('.uploaded-images').append(file.previewElement);
            }
        },
        onRemoveFile(file, error, xhr) {
            this.errorUploadFiles = document.querySelector('#dropzone').querySelectorAll('.-error').length > 0;
            const removedFile = this.uploadedFiles.find(item => item.name === file.name);
            if (removedFile) {
                this.formData[removedFile.type].splice( this.formData[removedFile.type].findIndex(item => item.url === removedFile.url), 1);
            }
            this.showMaxFileMessage = this.photosLength + this.documentsLength > 7 || this.photosLength > 5 || this.documentsLength > 2;
        },
        template: function () {
            return `<div class="upload-preview-wrapper">
                        <div class="upload-preview">
                            <div class="upload-preview-document hidden">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.75 12.5C1.75 13.7426 2.75736 14.75 4 14.75H10.2485C10.5513 14.75 10.8438 14.6401 11.0717 14.4407L13.8231 12.0332C14.0944 11.7958 14.25 11.4529 14.25 11.0925V4.5C14.25 3.25736 13.2426 2.25 12 2.25H4C2.75736 2.25 1.75 3.25736 1.75 4.5V12.5Z" stroke="#4578EB" stroke-width="1.5"/>
                                    <path d="M5.25 7H10.75" stroke="#4578EB" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M5.25 10H8.75" stroke="#4578EB" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <img src="" alt="" data-dz-thumbnail class="upload-preview-image">
                            <div class="upload-preview-name hidden"><span data-dz-name></span></div>
                            <div class="upload-preview-controls">
                                <a href="#" class="upload-preview-control" target="_blank" data-view>
                                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.6562 6.17188C13.7031 6.26562 13.7266 6.38281 13.7266 6.52344C13.7266 6.64062 13.7031 6.75781 13.6562 6.85156C12.3906 9.33594 9.85938 11 7 11C4.11719 11 1.58594 9.33594 0.320312 6.85156C0.273438 6.75781 0.25 6.64062 0.25 6.5C0.25 6.38281 0.273438 6.26562 0.320312 6.17188C1.58594 3.6875 4.11719 2 7 2C9.85938 2 12.3906 3.6875 13.6562 6.17188ZM7 9.875V9.89844C8.85156 9.89844 10.375 8.375 10.375 6.52344V6.5C10.375 4.64844 8.85156 3.125 7 3.125C5.125 3.125 3.625 4.64844 3.625 6.5C3.625 8.375 5.125 9.875 7 9.875ZM7 4.25V4.27344C8.24219 4.27344 9.25 5.25781 9.25 6.5C9.25 7.74219 8.24219 8.75 7 8.75C5.75781 8.75 4.75 7.74219 4.75 6.5C4.75 6.3125 4.77344 6.10156 4.82031 5.91406C5.00781 6.05469 5.24219 6.125 5.5 6.125C6.10938 6.125 6.60156 5.63281 6.60156 5.02344C6.60156 4.76562 6.53125 4.53125 6.39062 4.34375C6.57812 4.29688 6.78906 4.27344 7 4.25Z" fill="#494B4E"/>
                                    </svg>
                                </a>
                                <button data-dz-remove class="upload-preview-control">
                                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 11.375V3.5H11V11.375C11 12.0078 10.4844 12.5 9.875 12.5H3.125C2.49219 12.5 2 12.0078 2 11.375ZM8.375 5.375V10.625C8.375 10.8359 8.53906 11 8.75 11C8.9375 11 9.125 10.8359 9.125 10.625V5.375C9.125 5.1875 8.9375 5 8.75 5C8.53906 5 8.375 5.1875 8.375 5.375ZM6.125 5.375V10.625C6.125 10.8359 6.28906 11 6.5 11C6.6875 11 6.875 10.8359 6.875 10.625V5.375C6.875 5.1875 6.6875 5 6.5 5C6.28906 5 6.125 5.1875 6.125 5.375ZM3.875 5.375V10.625C3.875 10.8359 4.03906 11 4.25 11C4.4375 11 4.625 10.8359 4.625 10.625V5.375C4.625 5.1875 4.4375 5 4.25 5C4.03906 5 3.875 5.1875 3.875 5.375ZM11.375 1.25C11.5625 1.25 11.75 1.4375 11.75 1.625V2.375C11.75 2.58594 11.5625 2.75 11.375 2.75H1.625C1.41406 2.75 1.25 2.58594 1.25 2.375V1.625C1.25 1.4375 1.41406 1.25 1.625 1.25H4.4375L4.64844 0.828125C4.74219 0.640625 4.92969 0.5 5.14062 0.5H7.83594C8.04688 0.5 8.23438 0.640625 8.32812 0.828125L8.5625 1.25H11.375Z" fill="#494B4E"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="upload-preview-error"><span data-dz-errormessage></span></div>
                    </div>`;
        },
        changePosition(value) {
            this.formData.position = value;
            this.showCustomPosition = value === 'Інше';
            if (value !== 'Інше' && this.formData.customPosition !== '') {
                this.formData.customPosition = ''
            }
        },
        submit() {
            this.formErrors = {};
            this.unknownProblem = false;
            let fetchUrl, formData;
            if (this.isEdit) {
                fetchUrl = `/test/${this.editedReviewId}/update`;
                formData = JSON.stringify({
                    comment: this.formData.comment,
                    conclusion: this.formData.conclusion
                })
            } else {
                fetchUrl = `/test/create`;
                formData = JSON.stringify(this.formData)
            }

            fetch(fetchUrl, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: formData
            }).then(res => res.json())
                .then(res => {
                    if(!res.status && res.messages) {
                        this.formErrors = res.messages;
                    } else if (!res.status) {
                        this.unknownProblem = true
                    }
                    this.formSent = res.status;
                }).catch((err) => {
                console.log(err);
            });
        },
        closeModal() {
            vueData.showReviewForm = false;
            if (this.isEdit && this.formSent) {
                window.location.reload();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";

.upload-section {
    text-align: center;

    &-icon {
        margin-bottom: -3rem;
    }

    &-title {
        font-size: 1.2rem;
        margin-bottom: 1rem;
    }

    &-text {
        font-size: 1rem;
        color: #494B4E;
    }

    &-btn {
        border-radius: 5px;
        border: 1px solid #EEE;
        padding: 0.8rem;
        color: $color-brand;
        display: inline-flex;
        align-items: center;

        &:hover {
            border-color: $color-brand;
            cursor: pointer;
        }
    }
}

.highlight {
    color: #4578EB;
}

.review-success-title {
    font-weight: 500;
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
    margin-top: 3rem;
    text-align: center;
}

.review {
    &-btn-block {
        margin-top: 2.4rem;

        @include responsive-below($sm) {
            margin-top: 1.8rem;
        }
    }
    &-subtitle {
        font-weight: 500;
        font-size: 1.6rem;
        margin-bottom: 2.4rem;

        @include responsive-below($sm) {
            font-size: 1.4rem;
        }
    }

    &-success {
        padding: 2rem 3rem 8rem;

        @include responsive-above($md) {
            width: 49rem;
        }

        &-text {
            margin-top: 0.5rem;
            font-size: 1.6rem;
            color: #494B4E;
        }
    }

    &-content {
        padding: 0 5rem 2.5rem;

        @include responsive-below($md) {
            padding: 0;
        }
    }
    &-title {
        font-size: 3rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 4rem;
        margin-top: 2rem;

        @include responsive-below($lg) {
            padding: 0 4rem;
        }

        @include responsive-below($xs) {
            margin-bottom: 4.8rem;
            font-size: 2rem;
            text-align: left;
            padding-left: 0;
        }
    }

    &-group {
        margin-bottom: 1.2rem;

        @include responsive-below($sm) {
            margin-bottom: 0.8rem;
        }
    }

    &-area {
        width: 100%;
        resize: none;
        padding: 1.2rem 2rem;
        font-size: 1.4rem;
        line-height: 1.6;
        font-family: 'Ukraine';
        background-color: transparent;
        border: 0;

        &.simple {
            background: #F8F8F8;
            border: 1px solid #F8F8F8;
            border-radius: 0.8rem;

            &.error {
                border-color: #B70000;
            }

            &:focus {
                background-color: #fff;
                border-color: $color-brand;
            }
        }

        &::placeholder {
            font-size: 1.4rem;
            color: #25252550;

            @include responsive-below($sm) {
                font-size: 1.2rem;
            }
        }

        &:focus {
            outline: none;
        }

        &-wrapper {
            position: relative;
            background: #F8F8F8;
            border: 1px solid #F8F8F8;
            border-radius: 0.8rem;
            padding-bottom: 3rem;

            &.error {
                border-color: #B70000;
            }

            &.focus {
                background-color: #fff;
                border-color: $color-brand;
            }
        }

        &-counter {
            position: absolute;
            left: 2rem;
            bottom: 0.8rem;
            font-size: 1.2rem;

            @include responsive-below($sm) {
                left: 1.2rem;
            }
        }

        @include responsive-below($sm) {
            padding: 1.2rem;
        }
    }
}

</style>
